import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteCustomerApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteCustomer = createAsyncThunk('deleteCustomer', async (payload) => {
  return await deleteCustomerApi(payload);
});

const deleteCustomerSlice = createSlice({
  name: 'deleteCustomer', // Unique Name
  initialState,
  reducers: {
    deleteCustomerReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteCustomer.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteCustomer.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteCustomerReset } = deleteCustomerSlice.actions;

export default deleteCustomerSlice.reducer;
